import { sendMessageToWorkerWithResponse, constants } from 'helpers'
import { mergeClientsWithTransactions } from 'datastores/Merger'
import type { ClientType } from 'storeTypes/clientSearchTypes'
import type {
    TransactionPayloadType,
    ClientDetailsPayloadInterface
} from 'storeTypes'
import type { ThunkDispatch, AnyAction } from '@reduxjs/toolkit'

export async function updateClientsWithTransactions(
    villageId: string,
    transactions: TransactionPayloadType[],
    dispatch: ThunkDispatch<unknown, unknown, AnyAction>,
    clientList?: ClientDetailsPayloadInterface[],
    refreshAction?: (payload: {
        villageId: string
        clients: ClientType[]
    }) => unknown
) {
    if (clientList && clientList.length > 0) {
        const clientsWithTransactions = mergeClientsWithTransactions(
            clientList,
            transactions || []
        )

        if (refreshAction) {
            return dispatch(
                refreshAction({
                    villageId,
                    clients: clientsWithTransactions as unknown as ClientType[]
                }) as AnyAction
            )
        }
        return
    }
    const { storedData: clients } = await sendMessageToWorkerWithResponse({
        [constants.MESSAGES.GET_CLIENTS]: {
            villageIds: [villageId],
            clientType: constants.CLIENT_TYPES.ALL_CLIENT,
            filter: 'village'
        }
    })

    if (clients?.length > 0) {
        const clientsWithTransactions = mergeClientsWithTransactions(
            clients,
            transactions
        )
        if (refreshAction) {
            return dispatch(
                refreshAction({
                    villageId,
                    clients: clientsWithTransactions as unknown as ClientType[]
                }) as AnyAction
            )
        }
    }
}
